import { render, staticRenderFns } from "./SelesaiMaklGaji.vue?vue&type=template&id=787b0b2c&scoped=true&"
import script from "./SelesaiMaklGaji.vue?vue&type=script&lang=js&"
export * from "./SelesaiMaklGaji.vue?vue&type=script&lang=js&"
import style0 from "./SelesaiMaklGaji.vue?vue&type=style&index=0&id=787b0b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b0b2c",
  null
  
)

export default component.exports